import {
  format as formatUtil,
  utc as utcUtil,
  tz as tzUtil,
  epoch as epochUtil,
  formatEpochAsDate,
  formatEpochAsTime,
  formatEpochAsDateTime
} from '__core/shared/util/datetime';

/* @ngInject */

/* @ngInject */

export default ($rootScope) => {
  const getCurrentTimeZone = () => $rootScope.CurrentTimeZone();
  const getCurrentLocale = () => $rootScope.CurrentLocale();
  const getCurrentDateFormat = () => $rootScope.CurrentDateFormat();
  const getCurrentTimeFormat = () => $rootScope.CurrentTimeFormat();

  const format = (luxonDateTime) => formatUtil(luxonDateTime, getCurrentLocale(), null, null);

  const utc = (epochTimeStamp) => utcUtil(epochTimeStamp);

  const tz = (luxonDateTime, timeZone) =>
    tzUtil(luxonDateTime, timeZone || getCurrentTimeZone());

  const epoch = (luxonDateTime) => epochUtil(luxonDateTime);

  const getMoment = (_dateTime, _timeZone) =>
    moment.utc(_dateTime, 'X').tz(!_timeZone ? 'UTC' : _timeZone);

  const getFormattedDate = (timeStamp) =>
    formatEpochAsDate(timeStamp, getCurrentTimeZone(), getCurrentLocale());

  const getFormattedTime = (timeStamp) =>
    formatEpochAsTime(timeStamp, getCurrentTimeZone(), getCurrentLocale());

  const getFormattedDateTime = (timeStamp) =>
    formatEpochAsDateTime(timeStamp, getCurrentTimeZone(), getCurrentLocale());

  const setDate = (date, organizationTimeZone, hasArguments) => {
    const browserTimezone = moment.tz.guess();
    let dObject = '';
    const d = hasArguments ? moment.utc(date).format() : moment.utc(date, 'X').format();
    const dateOrg = moment(d).tz(organizationTimeZone).format('YYYY-MM-DD');
    const dateBrw = moment(d).tz(browserTimezone).format('YYYY-MM-DD');
    if (hasArguments) {
      if (moment(dateBrw).isAfter(dateOrg, 'day')) {
        dObject = moment.utc(date).add(1, 'days').format('YYYY-MM-DD');
      } else if (moment(dateBrw).isBefore(dateOrg, 'day')) {
        dObject = moment.utc(date).subtract(1, 'days').format('YYYY-MM-DD');
      } else {
        dObject = moment(d).format('YYYY-MM-DD');
      }
    } else if (moment(dateOrg).isAfter(dateBrw, 'day')) {
      dObject = moment.utc(date, 'X').add(1, 'days').format('YYYY-MM-DD');
    } else if (moment(dateOrg).isBefore(dateBrw, 'day')) {
      dObject = moment.utc(date, 'X').subtract(1, 'days').format('YYYY-MM-DD');
    } else {
      dObject = moment(d).format('YYYY-MM-DD');
    }
    return dObject;
  };

  const getSet = (obj, model, propertyPath, getterSetterName, reset) => {
    if (reset === true) {
      delete obj[`__${getterSetterName}`];
    }
    if (!angular.isDefined(obj[`__${getterSetterName}`])) {
      obj[`__${getterSetterName}`] = _.get(model, propertyPath)
        ? setDate(String(_.get(model, propertyPath)), getCurrentTimeZone(), false)
        : '';
    }
    obj[getterSetterName] = (input) => {
      if (angular.isDefined(input)) {
        obj[`__${getterSetterName}`] =
          input !== null ? setDate(input, getCurrentTimeZone(), true) : '';
        _.set(
          model,
          propertyPath,
          input !== null
            ? parseInt(moment.utc(obj[`__${getterSetterName}`]).startOf('day').format('X'), 10)
            : 0
        );
      }
      return obj[`__${getterSetterName}`];
    };
    return obj;
  };

  return {
    getCurrentTimeZone,
    getCurrentDateFormat,
    getCurrentTimeFormat,
    getCurrentLocale,
    format,
    utc,
    tz,
    epoch,
    getMoment,
    getFormattedDate,
    getFormattedTime,
    getFormattedDateTime,
    getSet,
    setDate
  };
};
